import { createSelector, createSlice } from '@reduxjs/toolkit';
import { uuid4 } from '../utils/uuid';
export const initialState = {
  byId: {},
  displayOrder: []
};
export const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    addAlert: (state, action) => {
      const id = uuid4();
      state.byId[id] = Object.assign({
        id,
        visuallyHidden: false
      }, action.payload);
      state.displayOrder.push(id);
    },
    setAlertVisibility: (state, action) => {
      if (state.byId[action.payload.id]) {
        state.byId[action.payload.id].visuallyHidden = action.payload.visuallyHidden;
      }
    },
    removeAlert: (state, action) => {
      if (state.byId[action.payload.id]) {
        delete state.byId[action.payload.id];
        state.displayOrder = state.displayOrder.filter(id => id !== action.payload.id);
      }
    }
  }
});
const getAlertsState = state => state.alerts;
export const getAlerts = createSelector([getAlertsState], alertsState => {
  return alertsState.displayOrder.map(id => alertsState.byId[id]);
});
export const {
  addAlert,
  setAlertVisibility,
  removeAlert
} = alertsSlice.actions;
export default alertsSlice.reducer;